/**
 * 기록 제목 표시 — 시스템이 만든 제목(변경관리 자동 생성·자격인증서 등)은 4개 언어 맵(titleI18n)으로 저장돼
 * 보는 사람 언어로 보이고, 사용자가 입력·수정한 제목(맵 없음)은 입력한 그대로 보인다.
 * 검색·정렬은 항상 기준 제목 `title` 을 쓴다(이 함수는 표시 전용).
 */
import { resolveLabel } from "@/lib/i18n/resolveLabel";

/** 제목과 시스템 제목 맵만 가진 기록 모양 — 목록 행·드로어 아이템 공용. */
export interface TitledItem {
  title?: string | null;
  titleI18n?: Record<string, string | undefined> | null;
}

/** 연계 기록(관계 응답)의 상대 제목 → 표시 문구 — toTitle 기준, 시스템 생성 제목 맵(toTitleI18n)이 있으면 보는 사람 언어. */
export function relationTitle(
  rel: { toTitle?: string | null; toTitleI18n?: Record<string, string | undefined> | null },
  lang: string,
): string {
  return itemTitle({ title: rel.toTitle, titleI18n: rel.toTitleI18n }, lang);
}

/**
 * 기록 제목 → 표시 문구.
 * @param item 제목 보유 기록(title 은 없을 수 있음)
 * @param lang 현재 UI 언어(ko/en/zh/ja)
 */
export function itemTitle(item: TitledItem, lang: string): string {
  return resolveLabel(item.title ?? "", item.titleI18n, lang);
}
